import ConfirmationAndOtpDialog from './ConfirmationAndOtpDialog';

export default ConfirmationAndOtpDialog;